import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {SurchargeAuditReportData} from "./surcharge-audit-report.data";

@Injectable()
export class SurchargeAuditReportModel extends ReportModel<SurchargeAuditReportData> {
    constructor(injector: Injector) {
        super(injector, SurchargeAuditReportData);
    }
}
